<section fxLayoutAlign="end center">
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</section>

<section fxFlexFill fxLayout fxLayoutAlign="center center">
  <div class="fs-dialog-contents">
    <h2 style="margin-bottom: 20px">
      Do you want to set {{ dialogData.listing.name }} as the lead listing for this property.
    </h2>

    <p class="night-darker text__medium" style="padding-top: 16px">Here's what will happen if you do:</p>

    <ul>
      <li>
        Property details and fee information will be populated from this listing (provided it's an Airbnb listing).
      </li>
      <li>
        This information is used to help populate your property details on any Direct booking websites that you have
        with
        {{ 'CORE.PRODUCT_NAME' | transloco }}
      </li>
      <!-- <li>
        If you make changes to price, availability, or minimum length of stay
        directly on this listing, we'll pull those changes in to your
        Hospitable.com calendar.
      </li> -->
    </ul>

    <div style="margin-top: 36px" fxLayout fxLayoutGap="16px" fxLayoutAlign="end center">
      <sbnb-button type="secondary" label="Cancel" (click)="dialogRef.close()"></sbnb-button>

      <sbnb-button
        type="primary"
        label="Set as lead listing"
        [loading]="setting"
        (click)="confirmAsLeadListing()"></sbnb-button>
    </div>
  </div>
</section>
